export default function SectionApp() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-lg border border-background-200 p-8 md:p-10 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-shrink-0">
            <div className="w-28 h-28 rounded-2xl bg-primary-500 flex items-center justify-center">
              <i className="ri-smartphone-line text-white text-5xl"></i>
            </div>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
              移动端观影体验
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-5">
              天狼影院完美适配手机和平板浏览器，无需下载APP即可享受流畅的高清观影体验。通过手机浏览器访问，随时随地追剧看电影，横屏竖屏自由切换。
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
              <button className="px-6 py-2.5 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm">
                <i className="ri-android-line mr-2"></i>
                Android 访问
              </button>
              <button className="px-6 py-2.5 border border-foreground-200 text-foreground-700 font-medium rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer text-sm">
                <i className="ri-apple-line mr-2"></i>
                iOS 访问
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}